import { action } from "@ember/object";
import { setOwner } from "@ember/owner";
import { service } from "@ember/service";
import uniqueId from "discourse/helpers/unique-id";
import { TOAST } from "float-kit/lib/constants";
export default class DToastInstance {
  static {
    dt7948.g(this.prototype, "site", [service]);
  }
  #site = (dt7948.i(this, "site"), void 0);
  static {
    dt7948.g(this.prototype, "toasts", [service]);
  }
  #toasts = (dt7948.i(this, "toasts"), void 0);
  options = null;
  id = uniqueId();
  constructor(owner, options = {}) {
    setOwner(this, owner);
    this.options = {
      ...TOAST.options,
      ...options
    };
  }
  close() {
    this.toasts.close(this);
  }
  static {
    dt7948.n(this.prototype, "close", [action]);
  }
  get isValidForView() {
    return this.options.views.includes(this.site.desktopView ? "desktop" : "mobile");
  }
}